import { useId } from "react";
export var useIdSafely = function() {
    if (useId) {
        return useId();
    }
};
export default useIdSafely;
